import { render, staticRenderFns } from "./SolutionCostsTable.vue?vue&type=template&id=34f630b4&scoped=true&"
import script from "./SolutionCostsTable.vue?vue&type=script&lang=js&"
export * from "./SolutionCostsTable.vue?vue&type=script&lang=js&"
import style0 from "./SolutionCostsTable.vue?vue&type=style&index=0&id=34f630b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f630b4",
  null
  
)

export default component.exports